import PermissionCode from 'types/enums/PermissionCode';

export const hasPermission = (permissions: string[], permission: PermissionCode): boolean =>
  permissions.includes(permission);
